export const parrotDarkBlue = "#003366";
export const parrotDarkerBlue = "#011a32";
export const parrotTextDarkBlue = "#00008B";
export const parrotButtonDarkBlue = "#005187";
export const parrotBlue = "rgb(10, 119, 234)";
export const parrotBlueTransparent = "rgba(0, 119, 234, 0.06)";
export const parrotBlueSemiTransparent = "rgba(0, 119, 234, 0.2)";
export const parrotBlueDarkTransparent = "rgba(0, 119, 234, 0.3)";
export const parrotBlueDarkTransparent2 = "rgba(0, 119, 234, 0.5)";
export const parrotGreen = "rgb(42, 200, 152)";
export const parrotButtonGreen = "#004422";
export const parrotGreenTransparent = "rgba(42, 200, 152, 0.06)";
export const parrotGreyTransparent = "rgb(246, 246, 246)";
export const parrotRed = "#CB0404";
export const parrotPlaceholderGrey = "#a3b4c5";
export const parrotLightBlue = "#3c9dde";
export const parrotPistachioGreen = "#9Bd35A"
export const parrotBananaLeafGreen = "#689F38";
export const parrotCream = "#f9f5f1";